import React from 'react';
import { Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import { dataFormStyles } from '~/modules/covenants/CovenantsDataForm/styles.ts';
import { guaranteesClientText } from '~/modules/guarantees/form/client/constants.ts';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import type { TGuaranteesContractOption } from '../../../rootSection/types.ts';
import { formatGuaranteesSummaryValue } from '../../../utils/display/utils.ts';

interface IMainDealTableRowProps {
  isDisabled: boolean;
  isSelected: boolean;
  option: TGuaranteesContractOption;
  onContractSelect: (option: TGuaranteesContractOption) => void;
}

const MainDealTableRow: React.FC<IMainDealTableRowProps> = ({
  isDisabled,
  isSelected,
  option,
  onContractSelect,
}) => (
  <TableRow
    hover
    onClick={() => {
      if (!isDisabled) {
        onContractSelect(option);
      }
    }}
    sx={guaranteesClientPageStyles.flowSelectableTableRow(isSelected)}
  >
    <TableCell sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'name')}>
      <Typography sx={guaranteesClientPageStyles.flowOptionTitle}>
        {option.mainDealNumber || guaranteesClientText.emptyValue}
      </Typography>
    </TableCell>
    <TableCell sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'createdAt')}>
      {formatGuaranteesSummaryValue(option.mainDealDate)}
    </TableCell>
    <TableCell sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'period')}>
      {formatGuaranteesSummaryValue(option.mainDealDateFrom)}
    </TableCell>
    <TableCell sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'period')}>
      {formatGuaranteesSummaryValue(option.mainDealDateTo)}
    </TableCell>
    <TableCell align="center" sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'status')}>
      {formatGuaranteesSummaryValue(option.mainDealCurrency)}
    </TableCell>
    <TableCell align="right" sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'amount')}>
      {formatGuaranteesSummaryValue(option.mainDealAmount)}
    </TableCell>
    <TableCell align="right" sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'amount')}>
      {formatGuaranteesSummaryValue(option.mainDealLimitBalance)}
    </TableCell>
    <TableCell align="center" sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'actions')}>
      <Checkbox
        checked={isSelected}
        disabled={isDisabled}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onChange={() => {
          if (!isDisabled) {
            onContractSelect(option);
          }
        }}
      />
    </TableCell>
  </TableRow>
);

export default MainDealTableRow;
